// api.ts
import axios from 'axios'
import endpoints from '../../endpoints'
import {TripNotStartedReportBase, TripNotStartedReportPayload} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchTripNotStartedReport(
  payload: TripNotStartedReportPayload
): Promise<APIResponse<TripNotStartedReportBase[]>> {
  const response = await axios.post(API_URL + endpoints.reports.tripNotStartedReport, payload)
  return response.data
}
